import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { isInt } from 'validator';

import { Container, Form } from '../../styles/GlobalStyles';
import { Titulo } from './styled';
import axios from '../../services/axios';

export default function Questoes({ match }) {
  const id = get(match, 'params.id', '');

  const questoes = get(match, 'params.questoes', '');

  const nivel = useSelector((state) => state.auth.user.nivel);

  const [numberPages, setNumberPages] = useState(1);
  const [prova, setProva] = useState(false);
  const [descricaoQuestao, setDescricaoQuestao] = useState('');
  const [tipoProva, setTipoProva] = useState('');
  const [peso, setPeso] = useState('');
  const [quantidadeAlternativa, setQuantidadeAlternativa] = useState('');
  const [alternativa1, setAlternativa1] = useState('');
  const [alternativa2, setAlternativa2] = useState('');
  const [alternativa3, setAlternativa3] = useState('');
  const [alternativa4, setAlternativa4] = useState('');
  const [alternativa5, setAlternativa5] = useState('');
  const [existe, setExiste] = useState(false);
  const [respostaCorreta, setRespostaCorreta] = useState('');

  useEffect(() => {
    function renderPage() {
      axios(`/questoes/${id}/${numberPages}`)
        .then((response) => {
          if (response.data) {
            setDescricaoQuestao(response.data.descricao_questao);
            setTipoProva(response.data.tipo_prova);
            setPeso(response.data.peso);
            setQuantidadeAlternativa(response.data.quantidade_de_alternativas);
            setExiste(true);
          } else {
            setExiste(false);
          }

          if (numberPages === Number(questoes)) {
            setProva(true);
          }

          return response.data.id;
        }).then((res) => {
          axios(`/alternativas/${res}`)
            .then((respon) => {
              if (document.querySelector('.alternativa0')) {
                document.querySelector('.alternativa0').value = respon.data.alternativas.alternativa_1;
                setAlternativa1(respon.data.alternativas.alternativa_1);
              } else {
                setAlternativa1('');
              }
              if (document.querySelector('.alternativa1')) {
                document.querySelector('.alternativa1').value = respon.data.alternativas.alternativa_2;
                setAlternativa2(respon.data.alternativas.alternativa_2);
              } else {
                setAlternativa2('');
              }
              if (document.querySelector('.alternativa2')) {
                document.querySelector('.alternativa2').value = respon.data.alternativas.alternativa_3;
                setAlternativa3(respon.data.alternativas.alternativa_3);
              } else {
                setAlternativa3('');
              }
              if (document.querySelector('.alternativa3')) {
                document.querySelector('.alternativa3').value = respon.data.alternativas.alternativa_4;
                setAlternativa4(respon.data.alternativas.alternativa_4);
              } else {
                setAlternativa4('');
              }
              if (document.querySelector('.alternativa4')) {
                document.querySelector('.alternativa4').value = respon.data.alternativas.alternativa_5;
                setAlternativa5(respon.data.alternativas.alternativa_5);
              } else {
                setAlternativa5('');
              }
              setRespostaCorreta(respon.data.resposta_correta);
            });
        }).catch(() => null);
    }

    renderPage();
  }, [numberPages, questoes, id]);

  const handlePages = async () => {
    let formErro = false;

    if (descricaoQuestao.length < 3) {
      toast.error('A descrição precisar ser maior que 3 caracteres');
      formErro = true;
    }

    if (document.getElementById('alternativa0') && (alternativa1.length < 1 || alternativa1.length > 255)) {
      toast.error('A alternativa 1 precisar ter entre 1 e 255 caracteres');
      formErro = true;
    }

    if (document.getElementById('alternativa1') && (alternativa2.length < 1 || alternativa2.length > 255)) {
      toast.error('A alternativa 2 precisar ter entre 1 e 255 caracteres');
      formErro = true;
    }

    if (document.getElementById('alternativa2') && (alternativa3.length < 1 || alternativa3.length > 255)) {
      toast.error('A alternativa 3 precisar ter entre 1 e 255 caracteres');
      formErro = true;
    }

    if (document.getElementById('alternativa3') && (alternativa4.length < 1 || alternativa4.length > 255)) {
      toast.error('A alternativa 4 precisar ter entre 1 e 255 caracteres');
      formErro = true;
    }

    if (document.getElementById('alternativa4') && (alternativa5.length < 1 || alternativa5.length > 255)) {
      toast.error('A alternativa 5 precisar ter entre 1 e 255 caracteres');
      formErro = true;
    }

    if (tipoProva < 1 || tipoProva > 3) {
      toast.error('O tipo de prova precisar ser entre 1 e 3');
      formErro = true;
    }

    if (!isInt(String(tipoProva))) {
      toast.error('Tipo de prova inválido!');
      formErro = true;
    }

    if (peso < 1 || peso > 3) {
      toast.error('O peso precisar ser entre 1 e 3');
      formErro = true;
    }

    if (!isInt(String(peso))) {
      toast.error('Peso da questão inválido!');
      formErro = true;
    }

    if (quantidadeAlternativa < 1 || quantidadeAlternativa > 5) {
      toast.error('A quantidade de questões deve ser entre 1 e 5');
      formErro = true;
    }

    if (!isInt(String(quantidadeAlternativa))) {
      toast.error('Quantidade de alternativas inválida!');
      formErro = true;
    }

    if (formErro) return;

    if (nivel === '1') {
      toast.error('Você não tem permissão para prosseguir com essa ação.');
      return;
    }

    if (!existe) {
      axios.post('/questoes/', {
        descricao_questao: descricaoQuestao,
        quantidade_de_alternativas: quantidadeAlternativa,
        peso,
        tipo_prova: tipoProva,
        numero_da_questao: numberPages,
        id_disciplina: id,
      }).then((res) => axios.post(
        '/alternativas/',
        {
          alternativa_1: alternativa1,
          alternativa_2: alternativa2,
          alternativa_3: alternativa3,
          alternativa_4: alternativa4,
          alternativa_5: alternativa5,
          resposta_correta: respostaCorreta,
          id_questoes: res.data.id,
        },
        toast.success('Questão cadastrada com sucesso!'),
      ).catch(() => {
        toast.error('Erro ao cadastrar a questão!');
      }));
    }

    if (existe) {
      axios.put(`/questoes/${id}/${numberPages}`, {
        descricao_questao: descricaoQuestao,
        quantidade_de_alternativas: quantidadeAlternativa,
        peso,
        tipo_prova: tipoProva,
        numero_da_questao: numberPages,
      }).then((res) => {
        axios.put(`/alternativas/${res.data.id}`, {
          alternativa_1: alternativa1,
          alternativa_2: alternativa2,
          alternativa_3: alternativa3,
          alternativa_4: alternativa4,
          alternativa_5: alternativa5,
          resposta_correta: respostaCorreta,
        }).catch(() => {
          toast.error('Error ao atualizar a alternativa');
        });
      }).then((res) => {
        toast.success('Questão editada com sucesso!');
      }).catch((err) => {
        toast.error('Error ao atualizar questão');
      });
    }

    setDescricaoQuestao('');
    setTipoProva('');
    setPeso('');
    setQuantidadeAlternativa('');
    setAlternativa1('');
    setAlternativa2('');
    setAlternativa3('');
    setAlternativa4('');
    setAlternativa5('');
    setRespostaCorreta('');

    if (numberPages === Number(questoes)) {
      setProva(true);
    }

    setNumberPages(numberPages + 1);
  };

  document.addEventListener('input', (e) => {
    const element = e.target;

    if (element.classList.contains('alternativa0')) {
      setAlternativa1(element.value);
    }

    if (element.classList.contains('alternativa1')) {
      setAlternativa2(element.value);
    }

    if (element.classList.contains('alternativa2')) {
      setAlternativa3(element.value);
    }

    if (element.classList.contains('alternativa3')) {
      setAlternativa4(element.value);
    }

    if (element.classList.contains('alternativa4')) {
      setAlternativa5(element.value);
    }
  });

  const alternativas = [];

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < quantidadeAlternativa; i++) {
    if (quantidadeAlternativa > 0 && quantidadeAlternativa < 6) {
      alternativas.push(
        <label htmlFor={`alternativa${i}`} key={i}>
          alternativa
          {' '}
          {i + 1}
          <input
            className={`alternativa${i}`}
            id={`alternativa${i}`}
            type="text"
          />
        </label>,
      );
    }
  }

  return (
    <Container>

      <Titulo>
        Questão
        {' '}
        {numberPages}
      </Titulo>

      <Form>
        <label htmlFor="descricao-questao">
          Descrição da questão
          <input
            id="descricao-questao"
            type="text"
            value={descricaoQuestao}
            onChange={(e) => setDescricaoQuestao(e.target.value)}
            placeholder="Descrição da questão"
          />
        </label>
        <label htmlFor="tipo-prova">
          Tipo de prova
          <input
            id="tipo-prova"
            type="number"
            min={1}
            max={3}
            value={tipoProva}
            onChange={(e) => setTipoProva(e.target.value)}
            placeholder="Tipo de prova"
          />
        </label>
        <label htmlFor="peso">
          Peso
          <input
            id="peso"
            type="number"
            min={1}
            max={3}
            value={peso}
            onChange={(e) => setPeso(e.target.value)}
            placeholder="Peso"
          />
        </label>
        <label htmlFor="quantidade-alternativas">
          Quantidade de alternativas
          <input
            id="quantidade-alternativas"
            type="number"
            min={1}
            max={5}
            value={quantidadeAlternativa}
            onChange={(e) => setQuantidadeAlternativa(e.target.value)}
            placeholder="Quantidade de alternativas"
          />
        </label>
        <label htmlFor="numero-questao">
          Número da questão
          <input
            id="numero-questao"
            type="number"
            value={numberPages}
            min={1}
            max={questoes}
            disabled
            placeholder="Número da questão"
          />
        </label>
        {alternativas}

        {quantidadeAlternativa && (
        <label htmlFor="resposta">
          Resposta correta
          <input
            type="text"
            id="resposta"
            value={respostaCorreta}
            onChange={(e) => setRespostaCorreta(e.target.value)}
          />
        </label>
        )}

        <div id="submit-questoes">
          <Link onClick={handlePages} to={!prova ? `/questoes/${id}/${questoes}` : `/prova/${id}`}>
            {((!existe && numberPages !== Number(questoes))) ? 'Adicionar Questão' : ''}
            {((existe && numberPages !== Number(questoes))) ? 'Editar questão' : ''}
            {(numberPages === Number(questoes)) ? 'Finalizar prova' : ''}
          </Link>
        </div>
      </Form>

    </Container>
  );
}

Questoes.propTypes = {
  match: PropTypes.shape({}).isRequired,
};
